import { connect } from 'react-redux';
import * as R from 'ramda';
import FutureDate from './FutureDate';
import { fetchFutureSequences } from '../store/sequencingWizardSlice';

const mapState = R.applySpec({
  futureSequences: R.path(['loadingManagement', 'sequencingWizard', 'futureSequences']),
});

const mapDispatch = {
  fetchFutureSequences,
};

export default connect(mapState, mapDispatch)(FutureDate);
